import { Card, Stack } from '@mui/material';

const actionCardSx = { boxShadow: 'none' };
const contentCardSx = { overflow: 'hidden', boxShadow: 'none' };

export default function ClubTabLayout({ actions, children }) {
    return (
        <Stack spacing={2}>
            {actions ? (
                <Card sx={actionCardSx}>
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="center"
                        flexWrap="wrap"
                        gap={1}
                        sx={{ px: 2, py: 1.5 }}
                    >
                        {actions}
                    </Stack>
                </Card>
            ) : null}
            {children ? <Card sx={contentCardSx}>{children}</Card> : null}
        </Stack>
    );
}
